import {cloneDeep} from 'lodash'
import {ModuleFc} from '@/project'
import {updateObject} from '@/store/utils'
import {setCookie} from '@/lib/cookie'
import {
  BizState, 
  CreateBizPayload, 
  UpdatePayload,
} from './types'

export {BizState}

const initState: BizState = {
  id: '',
  name: '',
  isCorporate: null,
  corporationRegistration: '',
  bizRegistrationNumber: '',
  corporateRegistrationNumber: '',
  ownerName: '',
  ownerRegistrationNumber: '',
  bizPhoneNumber: '',
  ownerEmail: '',
  bizType: '',
  bizClass: '',
  address: '',
  taxRegistrationNumber: '',
  email: '',
  otherBizVerified: false,
  hasExpiredCertificate: false,
  bizs: [],
}

const module: ModuleFc<BizState> = (ctx) => ({
  namespaced: true,
  state: cloneDeep(initState),
  actions: {
    async getBiz({commit, state}, id) {
      const result = await ctx.$axios({
        url: '/bizs/$id',
        method: 'get',
        data: {
          get id() {
            return id || state.id
          },
        },
      })
      commit('update', result.data)
    },
    async createBiz({commit, getters}, payload: CreateBizPayload) {
      const result = await ctx.$axios({
        url: '/bizs',
        method: 'post',
        data: payload,
      })
      commit('update', result.data)
      const bizIds = [...getters.bizIds, result.data.id].join(',')
      setCookie({name: 'bizIds', value: bizIds})
    },
    async updateBiz({commit, state, dispatch}, payload: UpdatePayload = {}) {
      const {id, ...data} = payload
      const result = await ctx.$axios({
        url: '/bizs/$id',
        method: 'patch',
        data: {
          get id() {
            return id || state.id
          },
          ...data,
        },
      })
      dispatch('getBiz')
      commit('update', result.data)
    },
    async checkBizExists(_, payload: {registrationNumber: string}) {
      const {data: {result}} = await ctx.$axios({
        url: '/sign-up/biz/check-biz-exists',
        method: 'post',
        data: {
          registrationNumber: payload.registrationNumber
        },
      }) as any
      return result
    },
    async refreshMatchToken(_, token: string) {
      const res = await ctx.$axios({
        url: `/bizs/refresh_match_token/${token}/`,
        method: 'post',
      })
      return res.data
    }
  },
  getters: {
    hasBiz(state) {
      return Boolean(state.bizs.length)
    },
    firstBiz(state) {
      const [firstBiz] = state.bizs
      return firstBiz
    },
    firstBizId(state, getters) {
      return getters.firstBiz?.id
    },
    bizIds(state) {
      return state.bizs.map((biz) => biz.id)
    }
  },
  mutations: {
    update(state, payload: BizState) {
      updateObject<BizState>(state, payload)
    },
    clear(state) {
      updateObject(state, initState)
    },
    selectBiz(state, payload: string) {
      const selectedBiz = state.bizs.find((biz) => biz.id === payload)
      updateObject<BizState>(state, selectedBiz || {})
    },
  },
})

export default module
